import Tooltip from '../helpers/Tooltip';

;$(function() {

	$('[data-tooltip]').each(i => {
		let item = $('[data-tooltip]').eq(i);
		item.append('<span class="tooltip" role="tooltip">' + item.data('tooltip') + '</span>');
	});

	$('[data-tooltip-toggle]').each(i =>{
		$('[data-tooltip-toggle]').eq(i).click(function(){ Tooltip.toggle($(this)); });
	});

});